import { color } from "@/styles/tokens";
import type { _SVGIcon } from "hsl-core/Components";

export const FILL = color.border.ctaSecondary;

const body: _SVGIcon.IconBody = (params) => {
	const fill = params?.fill ?? FILL;
	return `
   <g clip-path="url(#clip0_19154_155146)">
    <path d="M14 18H0V0H9.31895L14 4.54713V18Z" fill="${fill}"/>
    <path d="M7.7865 1.61914V5.57848H12.3381V16.3807H1.66016V1.61914H7.7865Z" fill="white"/>
    <path d="M11.0239 3.95945H9.44922V2.42896C9.96694 2.93912 10.5817 3.37165 11.0239 3.95945Z" fill="white"/>
    <path d="M11.2617 11.5897C10.8626 12.0776 9.64382 11.8226 9.11531 11.6451C8.73781 11.512 8.30638 11.1571 7.93966 11.1904C7.67001 11.2126 5.51285 11.8226 5.34028 11.9446C5.12456 12.0887 4.7902 12.9427 4.58527 13.2422C4.21855 13.7634 3.59297 14.5176 2.92425 14.0629C1.93195 13.3752 3.61454 12.1775 4.16462 11.8336C4.35877 11.7117 4.77941 11.6118 4.8657 11.5231C4.97356 11.4122 5.96585 8.85028 5.98743 8.67284C6.01978 8.27357 5.44813 7.45287 5.60992 6.4769C5.87957 4.87986 7.21701 5.16821 7.06601 6.98707C7.02286 7.44178 6.613 8.34012 6.64536 8.61738C6.67772 8.96119 7.85337 10.4695 8.18773 10.5361C8.38188 10.5804 9.32024 10.3475 9.75168 10.3697C10.2802 10.403 11.8333 10.8909 11.2509 11.6118L11.2617 11.5897Z" fill="${fill}"/>
  </g>
  <defs>
    <clipPath id="clip0_19154_155146">
      <rect width="14" height="18" fill="white"/>
    </clipPath>
  </defs>
  `;
};

export default {
	W: 14,
	H: 18,
	body,
} as _SVGIcon.Icon;
